import { ImportConfigurationEditFormsCoordinatorService } from '../import-configuration-edit-forms-coordinator.service';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ImportConfigurationTimeSceduleFormType } from './configuration-form-timescedule-form-type';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DaySelectorComponent } from './day-selector/day-selector.component';
import { NgClass } from '@angular/common';
import { YesNoGroupButtonComponent } from '../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { AppErrorMessagesComponent } from '../../../../../base/error-messages/app-error-messages.component';
import { DatePickerModule, MaskedDateTimeService, TimePickerModule } from '@syncfusion/ej2-angular-calendars';

@Component({
    selector: 'app-configuration-form-timescedule',
    templateUrl: './configuration-form-timescedule.component.html',
    styleUrls: ['./configuration-form-timescedule.component.scss'],
    imports: [ReactiveFormsModule, DatePickerModule, AppErrorMessagesComponent, YesNoGroupButtonComponent, NgClass, TimePickerModule, DaySelectorComponent, TranslateModule],
    providers: [MaskedDateTimeService]
})
export class ConfigurationFormTimesceduleComponent implements OnInit{

  public get configurationFormTimescedule(): FormGroup<ImportConfigurationTimeSceduleFormType> {
    return this.formsCoordinationService.configurationFormTimeschedule;
  }

  constructor(
    public formsCoordinationService: ImportConfigurationEditFormsCoordinatorService,
  ) { }

  ngOnInit() {
    this.configurationFormTimescedule.controls.hasEndDate.valueChanges.subscribe(() => {
      this.formsCoordinationService.setValidatorsForTimeScheduleConfigForm();
    });
  }
}
